import React from 'jsx-dom';
export const UIPSnippetsIcon = () => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', stroke: 'black', viewBox: '0 0 16 9', xmlSpace: 'preserve' },
    React.createElement("polyline", { points: '0,0 8,8 16,0', "stroke-width": '2' })));
